import React from 'react'

export default function Contact() {
  return (
    <div className='contact'>
        <main>
            <h2>
                Contact Us
            </h2>
            <form  >
                <div>
                    <label>Name</label>
                    <input type="text" required placeholder='ABC' />
                </div>
                <div>
                    <label>Email</label>
                    <input type="email" required placeholder='ABC@xyz.com' />
                </div>
                <div>
                    <label>Message</label>
                    <input type="text" required placeholder='Enter your message' />
                </div>
                <button type='submit'>Submit</button>
            </form>
        </main>
        
    </div>
  )
}
